import formatDate from './formatDateHelper'

const DOTTED_UTC_RE =
  /^(\d{1,2})\.(\d{1,2})\.(\d{4})\.?\s+(\d{1,2})[.:](\d{2})(?:[.:](\d{2}))?$/;

const DASH_SPLIT_RE = /\s*[-–—]\s*/

function normalize(s) {
  return String(s)
    .normalize('NFKC')
    .replace(/\u00A0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

function parseDottedUtcToDate(input) {
  const s = String(input).normalize('NFKC').replace(/\u00A0/g, ' ').trim();
  const m = DOTTED_UTC_RE.exec(s);
  if (!m) return null;
  const dd = +m[1];
  const MM = +m[2] - 1;
  const yyyy = +m[3];
  const HH = +m[4];
  const mm = +m[5];
  const ss = m[6] ? +m[6] : 0;
  return new Date(Date.UTC(yyyy, MM, dd, HH, mm, ss));
}
/**
 * Convert a UTC range like "25.08.2025. 03:38:44 - 25.08.2025. 15:05:44"
 * into a localized string using your i18n date formats.
 */
export default function formatUtcRangeToLocal(
  rangeStr,
  type = 'long',
  joiner = ' - '
) {
  if (!rangeStr || typeof rangeStr !== 'string') return rangeStr

  const parts = normalize(rangeStr).split(DASH_SPLIT_RE)
  if (parts.length !== 2) return rangeStr

  const leftUtc = parseDottedUtcToDate(parts[0])
  const rightUtc = parseDottedUtcToDate(parts[1])

  if (!leftUtc || !rightUtc) {
    return rangeStr
  }

  const leftLocal = formatDate(leftUtc, type, false)
  const rightLocal = formatDate(rightUtc, type, false)

  return `${leftLocal}${joiner}${rightLocal}`
}